import { createReducer } from 'redux-create-reducer';

import {
  FETCH_CONDITIONS_REQUEST,
  FETCH_CONDITIONS_SUCCESS,
  RESET_CONDITIONS_SUCCESS,
} from 'js/components/shared/constants';

const initialState = {
  fetching: false,
  fetched: false,
}

export default createReducer(initialState, {
  [FETCH_CONDITIONS_REQUEST](state) {
    return {
      ...state,
      fetching: true,
    }
  },
  [FETCH_CONDITIONS_SUCCESS](state, { payload }) {
    return {
      ...state,
      ...payload,
      fetching: false,
      fetched: true,
    }
  },
  [RESET_CONDITIONS_SUCCESS]() {
    return initialState
  },
})
